import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useAppSelector } from 'hooks/reduxHooks'
import withMountGuard from 'hocs/withMountGuard'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { LUX_PLUS_GIFT_CARD_CAMPAIGN } from 'luxPlus/constants/base'
import GiftCardIcon from 'LuxKit/Icons/custom/GiftCardIcon'
import PageBanner from 'LuxKit/Banners/PageBanner'
import Colour from 'components/utils/Colour'
import { getThemeClassName } from 'lib/theme/themeUtils'
import LuxPlusMonthTakeoverBackground from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthTakeoverBackground'
import styled from 'styled-components'
import TextLink from 'LuxKit/TextLink'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useLuxPlusGiftCardBanner from 'luxPlus/hooks/useLuxPlusGiftCardBanner'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'

const BannerWrapper = styled.div`
  position: relative;
`

const Background = styled(LuxPlusMonthTakeoverBackground)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Content = styled.div`
  position: relative;
`

function LuxPlusGiftCardOfferBanner() {
  const {
    showBanner,
    onDismiss,
    ctaLabel,
    ctaTo,
    ctaHref,
    ctaOnClick,
  } = useLuxPlusGiftCardBanner()

  if (!showBanner) return null

  return (
    <BannerWrapper>
      <Background />
      <Content className={getThemeClassName({ mobile: 'inverse' })}>
        <CSSBreakpoint min="tablet">
          <PageBanner
            kind="none"
            density="compact"
            align="start"
            tabletAlign="center"
            icon={<GiftCardIcon size="M" />}
            primaryActionButtonProps={{
              children: ctaLabel,
              to: ctaTo,
              href: ctaHref,
              onClick: ctaOnClick,
              size: 'small',
            }}
            onDismiss={onDismiss}
          >
            <FormattedMessage
              id="w9VKULsBrz"
              defaultMessage="<bold>LuxPlus<plus>+</plus></bold> members save 5% on LE Gift Cards. Purchase gift cards with code <bold>{promoCode}</bold> at checkout*. Ends {endDate}. T&amp;Cs apply."
              description="LuxPlus+ gift card promotional banner message describing the offer details"
              values={{
                bold: (chunks) => <b>{chunks}</b>,
                plus: (chunks) => <Colour value="highlight-lux-plus">{chunks}</Colour>,
                promoCode: LUX_PLUS_GIFT_CARD_CAMPAIGN.PROMO_CODE,
                endDate: <FormatDateTime value={LUX_PLUS_GIFT_CARD_CAMPAIGN.END_DATE} day="numeric" month="short" year="numeric" />,
              }}
            />
          </PageBanner>
        </CSSBreakpoint>
        <CSSBreakpoint max="mobile">
          <PageBanner
            kind="none"
            density="compact"
            align="start"
            tabletAlign="center"
            onDismiss={onDismiss}
          >
            <BodyText variant="small">
              <FormattedMessage
                id="w9VKULsBrz"
                defaultMessage="<bold>LuxPlus<plus>+</plus></bold> members save 5% on LE Gift Cards. Purchase gift cards with code <bold>{promoCode}</bold> at checkout*. Ends {endDate}. T&amp;Cs apply."
                description="LuxPlus+ gift card promotional banner message describing the offer details"
                values={{
                  bold: (chunks) => <b>{chunks}</b>,
                  plus: (chunks) => <Colour value="highlight-lux-plus">{chunks}</Colour>,
                  promoCode: LUX_PLUS_GIFT_CARD_CAMPAIGN.PROMO_CODE,
                  endDate: <FormatDateTime value={LUX_PLUS_GIFT_CARD_CAMPAIGN.END_DATE} day="numeric" month="short" year="numeric" />,
                }}
              />{' '}<TextLink
                to={ctaTo}
                href={ctaHref}
                onClick={ctaOnClick}
                size="caption"
              >{ctaLabel}
              </TextLink>
            </BodyText>
          </PageBanner>
        </CSSBreakpoint>
      </Content>
    </BannerWrapper>
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsLuxPlusEnabled)
})(LuxPlusGiftCardOfferBanner)
